import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=05950ddb&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=05950ddb&prod&lang=css&"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=05950ddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05950ddb",
  null
  
)

export default component.exports